import React, { useContext, useState, useEffect, useMemo } from 'react';
import { fetchData } from '../service/data.service';

const DepressionContext = React.createContext();

export const useDepressionContext = () => useContext(DepressionContext);

export function DepressionProvider({ children }) {
  const [banner, setBanner] = useState({});
  const [experienceFirst, setExperienceFirst] = useState({});
  const [experienceSecond, setExperienceSecond] = useState({});
  const [sharedApp, setSharedApp] = useState({});
  const [article, setArticle] = useState([]);
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetchData.get('https://run.mocky.io/v3/00f455a2-299a-43cf-a1fc-0db59b0fac8d').then(setBanner);
    fetchData
      .get('https://run.mocky.io/v3/26973a3d-5317-42f9-8dd9-aa1e782b3de6')
      .then(setExperienceFirst);
    fetchData
      .get('https://run.mocky.io/v3/ad14c71c-3af3-416a-839b-fb0f36c1cb86')
      .then(setExperienceSecond);
    fetchData
      .get('https://run.mocky.io/v3/a8b819cc-3659-47e9-a725-d9759068cf90')
      .then(setSharedApp);
    fetchData.get('https://run.mocky.io/v3/d8a57089-024c-480f-93a4-9b7d5a0bacbd').then(setArticle);
    fetchData.get('https://run.mocky.io/v3/848951b6-d37d-4040-9d6d-8dd45caaa839').then(setVideos);
  }, []);

  const value = useMemo(
    () => ({
      banner,
      experienceFirst,
      experienceSecond,
      sharedApp,
      article,
      videos,
    }),
    [banner, experienceFirst, experienceSecond, sharedApp, article, videos]
  );

  return <DepressionContext.Provider value={value}>{children}</DepressionContext.Provider>;
}
